export default ({ store }) => {
  let unwatch

  // Watch the authenticated getter and if it turns true run the hydrate function
  // and unwatch the authenticated getter.
  unwatch = store.watch(
    (state, getter) => getter.authenticated,
    authenticated => authenticated && store.getters.activeTeam && hydrate(store, unwatch)
  )
}

const hydrate = (store, unwatchFn) => {
  hydrateActiveTimer(store)
  unwatchFn()
}

const hydrateActiveTimer = store => store.dispatch('fetchActiveTimeEntry')
